export default __webpack_public_path__ + "static/media/cal2.efa11c30.svg";